export default __webpack_public_path__ + "static/media/caloToken3.4a61a3e2.png";